import React from "react";
import { Heading, Img } from "../../components";
import QuickAccessTile from "../../components/QuickAccessTile";
import { useNavigate } from "react-router-dom";   // ►


export default function DashboardMenu({ currentUser, counters = {} }) {
  const navigate = useNavigate();                // ►
const TILES = [
  {
    key: "ads_new",
    label: "מודעות חדשות",
  bg: "#D50000",             // Red
    icon: "/images/red-car.svg",
    star: true,
  onClick: () => navigate("/dealer-cars", {
        state: { defaultTab: "מודעות חדשות" },
      }),             },
  {
    key: "ads_all",
    label: "כל המודעות",
    bg: "#D50000",             // Red
    icon: "/images/red-car.svg",
       onClick: () => navigate("/dealer-cars", {
        state: { defaultTab: "כל המודעות" },
      }),          
  },
  {
    key: "offers_approved",
    label: "הצעות שאושרו",
    bg: "#4CAF50",             // Green
    icon: "/images/green-car.svg",
    onClick: () => navigate("/my-offers", {
        state: { defaultTab: "הצעות שאושרו" },
      }),       
  },
  {
    key: "ads_pending",
    label: "הצעות\nממתינות לאישור",
    bg: "#D50000",             // Red
    icon: "/images/red-car.svg",
        onClick: () => navigate("/my-offers", {
        state: { defaultTab: "הצעות ממתינות לאישור" },
      }),  
  },
/*  {
    key: "offers_new",
    label: "הצעות חדשות",
    bg: "#D50000",
    icon: "/images/img__20x20.svg",
  },*/
  {
    key: "ads_archive",
    label: "מודעות בארכיון",
    bg: "#757575",             // Gray
    icon: "/images/gray-car.svg",
           onClick: () => navigate("/dealer-cars", {
    state: { defaultTab: "מודעות בארכיון" },  // ← תואם בדיוק
      }),       
  },
 /* {
    key: "cars_auction",
    label: "רכבים למכרז",
    bg: "#FF8C42",             // Orange
    icon: "/images/img__20x20.svg",
  },*/
  {
    key: "bundles_auction",
    label: "חבילת רכבים",
    bg: "#FFB400",             // Yellow/Orange
    icon: "/images/orange-offer.svg",
  },
];

  

  return (
    <div
      className="dashboard-menu flex w-[16%] sm:w-[100%] flex-col gap-4 rounded-[24px] bg-secondary-primary_white px-6 shadow-xs"
    >
      {/* כותרת */}
    <div className=" flex gap-3 mt-4 dashboard-title" style={{justifyContent:'center'}}>
                           <Heading size="heading9xl" as="h4" className="!font-heebo text-[25px] font-bold lg:text-[21px]">
          גישה מהירה
                           </Heading>
        <Img src="/images/img_settings_red_a700_03.svg" alt="" className="mt-1 h-[28px]" />                         </div>
      <div className="h-px bg-blue_gray-100" />

      {/* ריבועים – שתי עמודות */}      
      <div className="dashboard-menu__tiles grid grid-cols-2 gap-2">
        {TILES.map((t) => (
          <QuickAccessTile
            key={t.key}
            count={counters[t.key] ?? 0}
            label={t.label}
            bg={t.bg}
            icon={t.icon}
            withStar={t.star}
            onClick={t.onClick}
          />
        ))}
      </div>
    </div>
  );
}
